import { createContext } from "react"

const GamesContext = createContext()
export default GamesContext
